import { BuildingStoryList } from "./LeftSidebar/BuildingStoryList";
import "./WelcomeFloorPicker.css";

export const WelcomeFloorPicker: React.FC = () => (
  <div className="floor-picker-page">
    <section className="floor-picker" aria-labelledby="floor-picker-title">
      <header className="floor-picker-header">
        <h1 id="floor-picker-title">Velg etasje</h1>
        <p>Velg bygning og etasje for å åpne modellen.</p>
      </header>
      <BuildingStoryList />
    </section>
  </div>
);
